export interface BillingInvoice {
  client_id: string;
  client_name: string;
  invoice_id: string;
  invoice_type: 'project_rate' | 'subscription_setup' | 'ad_hoc' | 'pakkelosning_combined';
  amount: string;
  billing_period: string | null;
  description: string | null;
  email_custom_text: string | null;
  status: 'draft' | 'postponed' | 'approved';
  triggered_at: string;
  approved_at: string | null;
  postpone_until_date: string | null;
  postpone_mode: 'new_trigger_task' | 'future_date' | null;
  postpone_reason: string | null;
  line_items: Array<{
    id: string;
    description: string;
    amount: string;
    quantity: string;
    source_type: string | null;
    source_id: string | null;
    position: number;
  }> | null;
}

export interface BillingClientGroup {
  clientId: string;
  clientName: string;
  invoices: BillingInvoice[];
}

export function groupByClient(rows: BillingInvoice[]): BillingClientGroup[] {
  const m = new Map<string, BillingClientGroup>();
  for (const r of rows) {
    let g = m.get(r.client_id);
    if (!g) {
      g = { clientId: r.client_id, clientName: r.client_name, invoices: [] };
      m.set(r.client_id, g);
    }
    g.invoices.push(r);
  }
  return [...m.values()].sort((a, b) => a.clientName.localeCompare(b.clientName, 'da'));
}
